import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatMessage } from '../../translations/connectedIntlProvider';
import Loader from '../../shared/components/Loader/Loader';
import Grid from '../../shared/components/Grid/Grid';
import { ButtonFormatter, DownloadFormatter } from '../../shared/components/Grid/GridFormatter';
import { faLayerGroup, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import IState from '../../core/models/IState';
import { toast } from 'react-toastify';
import DeletePopup from '../../shared/components/Popup/DeletePopup';
import './Download.css';
import DeletePopupHOC from '../../shared/components/Popup/hoc/DeletePopupHOC';
import Pagination from "../../shared/components/Grid/Pagination";
import IPageInfo from '../../models/IPageInfo';
import IPageLimit from '../../models/IPageLimit';
import downloadIcon from '../../assets/Images/download.png';
import useWindowDimensions from '../../helpers/windowResize.helper';
import { allFiles } from '../../core/selectors/downloadFile.selector';
import URLConstants from '../../core/constants/url.constants';
import { downloadCsv } from '../../core/services/services';
import DeleteAllFilesPopupHOC from '../../shared/components/Popup/hoc/DeleteAllFilesPopupHOC';
import DeleteAllPopup from '../../shared/components/Popup/DeleteAllPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fileStatusEnum from '../../constants/fileStatus.enum';
import NoDataComponent from '../../shared/components/NoData/NoDataComponent';
import FileIcon from '../../assets/Images/icon/svg/file-icon.svg'

const Download = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const [selectedId, setSelectedId] = useState<number>(0);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const dispatch = useDispatch();
  const { fileList, deleteFile, deleteSelectedFile }: any = useSelector((state: IState) => { return state.file });
  const language = useSelector((state: IState) => { return state.preferences.language });
  let lang: string;
  const pager: IPageLimit = useSelector((state: IState) => { return state.pager });
  const allUsersData: any = useSelector(allFiles);
  const userType: any = useSelector((state: IState) => { return state.auth.userType });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false
  });

  const { height, width } = useWindowDimensions();

  var windowHeight = width > 767 ? {
    maxHeight: height - 80
  } : {
    maxHeight: height - 125
  };

  const [selectedRows, setselectedRows] = useState<number[]>([])


  useEffect(() => {
    lang = language;
    dispatch(actions.getPageLimit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GetAllFiles = (currentPage: number, pagerSize: number) => {
    setselectedRows([])
    setDisablePagination(true);
    dispatch(actions.getAllFile(currentPage, pagerSize));
  }

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  }

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  }

  const onPageLimitChanged = (evt: any) => {
    let pages: number
    pages = props.data && Math.ceil(props.data.length / evt.target.value)
    setPageInfo({ ...pageInfo, currentPage: 1, totalPages: pages, isPagerChange: false });
    dispatch(actions.updatePagerPageLimit(evt.target.value));
  }

  const refreshClickHandler = () => {
    if (pager.isPageLimitLoaded) {
      GetAllFiles(pageInfo.currentPage, pager.pageLimit);
    }
  }

  useEffect(() => {
    if (language !== lang)
      refreshClickHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  useEffect(() => {
    if (!fileList.loading && fileList.files.FileList !== undefined && fileList.files.FileList.length >= 0) {
      setPageInfo({ ...pageInfo, totalPages: fileList.files.TotalPages });
      setDisablePagination(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileList.loading])

  useEffect(() => {
    if (pager.isPageLimitLoaded) {
      GetAllFiles(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pager.isPageLimitLoaded, pager.pageLimit]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      GetAllFiles(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (deleteFile.success) {
      toast.success(formatMessage('Message_File_Delete_Success'));
      dispatch(actions.resetDeleteFileState());
      props.deletePopupToggleHandler();
      GetAllFiles(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFile.success]);

  useEffect(() => {
    if (deleteFile.error != null)
      toast.error(formatMessage(deleteFile.error));
    dispatch(actions.resetDeleteFileState());
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [deleteFile.error]);

  useEffect(() => {
    if (fileList.error != null)
      toast.error(formatMessage(fileList.error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileList.error]);

  const deleteHandler = () => {
    dispatch(actions.deleteFile(selectedId));
  }

  const deleteClickHandler = (row: any) => {
    setSelectedId(row.id);
    props.deletePopupToggleHandler();
  }

  const downloadCSVFileHandler = (row: any) => {
    let url = URLConstants.DownloadCSVFile + '/' + row.id;
    downloadCsv(url, row.FileName);
  }

  const getStatus = (status: string) => {
    return formatMessage(status);
  };

  const columns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'FileName',
    text: formatMessage('Download_Label_File_Name')
  }, {
    dataField: 'Date',
    text: formatMessage('Download_Table_Col_Date')
  }, {
    dataField: 'Status',
    text: formatMessage('Download_Table_Col_Status'),
    formatter: (cell: string) => <span>{getStatus(cell)}</span>,
  }, {
    dataField: 'isDownload',
    formatter: DownloadFormatter(downloadCSVFileHandler, true, formatMessage('Button_Download')),
    text: ''
  }
    , {
    dataField: 'isDelete',
    formatter: ButtonFormatter(deleteClickHandler, faTrashAlt, true, formatMessage('Delete')),
    text: ''
  }];

  const handleSelectAll = (isSelect: boolean, rows: any[]) => {
    if (isSelect) {
      setselectedRows(rows.map((row: any) => row.id));
    } else {
      setselectedRows([]);
    }
  }

  const handleRowSelect = (row: any, checked: boolean) => {
    if (checked) {
      setselectedRows(prev => [...prev, row.id]);
    } else {
      setselectedRows(prev => prev.filter(i => i !== row.id));
    }
  }

  const selectRow = {
    mode: "checkbox",
    selected: selectedRows,
    onSelect: handleRowSelect,
    onSelectAll: handleSelectAll,
    nonSelectable:allUsersData?.filter((row:any)=>row.Status === fileStatusEnum[fileStatusEnum.Pending]).map((row:any)=>row.id),
    nonSelectableClasses:"checkbox-disabled"
  };

  const deleteSelectedHandler = () => {
    dispatch(actions.deleteSelectedFile(selectedRows));
    // setselectedRows([])
  }

  useEffect(() => {
    if (deleteSelectedFile.success) {
      toast.success(formatMessage('Message_File_Delete_Success'));
      dispatch(actions.resetDeleteSelectedFileState());
      props.deleteAllFilesToggleHandler();
      GetAllFiles(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSelectedFile.success]);

  return (
    <React.Fragment>
      {
        props.showDeletePopup &&
        <DeletePopup
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          isLoading={deleteFile.loading} />
      }

      {
        props.showDeleteAllFilesPopup &&
        <DeleteAllPopup
          modalSubmit={deleteSelectedHandler}
          modalClosed={props.deleteAllFilesToggleHandler}
          isLoading={false}
        />
      }

      <div className="icon-nav navbar-fixed-top device-nav-bar">
        <div className="container-fluid">
          <div className="filter-left-area">
            <ul>
              <li><h1><img src={downloadIcon} alt=""></img> <FormattedMessage id='Download_Title' /></h1></li>
            </ul>
          </div>

          <div className="add-list float-right">
            <ul>
              {selectedRows.length > 0 && (
                <li
                  className="p-1 flex items-center gap-2 cursor-pointer "
                  onClick={() => props.deleteAllFilesToggleHandler()}
                >
                  <FontAwesomeIcon icon={faLayerGroup} style={{ marginRight: '8px' }} />
                  <FormattedMessage id='DELETE_ALL' />
                </li>
              )}
              <li title={formatMessage('Refresh')}>
                <a data-toggle="modal" onClick={() => refreshClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                  </svg>
                </a>
              </li>
              <li className="page-number">
                <Pagination isRefreshPage={false} totalPages={pageInfo.totalPages} pageLimit={pager.pageLimit} onPageChanged={onPageChanged} disablePagination={disablePagination} setIsRefreshPage={setIsRefreshPage} />
              </li>
              <li className="page-count-no">
                <select className='pageLimit' onChange={onPageLimitChanged} value={pager.pageLimit}>
                  {pager.pageLimitOptions.map((op: any) => <option key={op} value={op}>{op}</option>)}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div className="container">
        <div className="device-detail">
          <div className="table-responsive" style={windowHeight}>
            {fileList.loading ? <Loader /> : allUsersData.length === 0 ?(
              <NoDataComponent image={FileIcon} message={'No_Csv_Files_Availabe'} imageAlt={'No Csv Files'}/>
            ) :
            (
              <Grid data={allUsersData} columns={columns} selectRow={selectRow} keyField="id" />
            )
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default injectIntl(DeletePopupHOC(DeleteAllFilesPopupHOC(Download)));